export const ENROLLMENTS_IS_FETCHING = 'ENROLLMENTS_IS_FETCHING';
export const ENROLLMENTS_GET_SUCCESS = 'ENROLLMENTS_GET_SUCCESS';
export const ENROLLMENTS_GET_ERROR = 'ENROLLMENTS_GET_ERROR';
